import React from 'react'

const Calendar = () => (
  <svg width='25px' height='25px' viewBox='0 0 64 64'>
    <g id='CALENDAR_1_'>
      <g id='CALENDAR'>
        <g>
          <path className='timesheets__icon'
          d="M48,14c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v8C45,12.657,46.343,14,48,14z M61,8h-6v3
          c0,3.866-3.134,7-7,7s-7-3.134-7-7V8H23v3c0,3.866-3.134,7-7,7s-7-3.134-7-7V8H3c-1.657,0-3,1.343-3,3v50c0,1.657,1.343,3,3,3h58
          c1.657,0,3-1.343,3-3V11C64,9.343,62.657,8,61,8z M58,58H6V24h52V58z M16,14c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3
          s-3,1.343-3,3v8C13,12.657,14.343,14,16,14z M26.361,39.632c-0.373,0.347-0.785,0.663-1.235,0.949
          c-0.451,0.286-0.875,0.567-1.274,0.845c-0.78,0.538-1.521,1.066-2.223,1.586c-0.702,0.521-1.313,1.088-1.833,1.703
          s-0.932,1.312-1.235,2.094c-0.304,0.779-0.455,1.698-0.455,2.756H31.47v-3.172h-8.606c0.451-0.625,0.97-1.17,1.56-1.639
          c0.589-0.468,1.196-0.904,1.82-1.312c0.624-0.407,1.244-0.819,1.859-1.235c0.615-0.416,1.166-0.88,1.651-1.392
          c0.485-0.51,0.875-1.096,1.17-1.754c0.294-0.66,0.442-1.447,0.442-2.367c0-0.883-0.169-1.68-0.507-2.392
          c-0.338-0.71-0.793-1.308-1.365-1.794c-0.572-0.485-1.235-0.858-1.989-1.118C26.751,31.13,25.958,31,25.126,31
          c-1.092,0-2.058,0.187-2.899,0.559c-0.841,0.373-1.539,0.893-2.093,1.56c-0.555,0.667-0.971,1.447-1.248,2.34
          c-0.277,0.893-0.399,1.859-0.364,2.898h3.536c0-0.484,0.048-0.975,0.143-1.469c0.095-0.494,0.255-0.945,0.481-1.352
          c0.225-0.407,0.524-0.737,0.897-0.988s0.828-0.377,1.365-0.377c0.797,0,1.452,0.247,1.963,0.741
          c0.511,0.494,0.767,1.183,0.767,2.067c0,0.555-0.126,1.049-0.377,1.481C27.045,38.895,26.733,39.285,26.361,39.632z
           M41.467,45.807c-0.269,0.321-0.598,0.582-0.988,0.78c-0.39,0.199-0.828,0.299-1.312,0.299c-0.832,0-1.518-0.247-2.055-0.741
          c-0.536-0.494-0.85-1.156-0.936-1.988h-3.692c0.017,0.953,0.211,1.789,0.584,2.509c0.373,0.719,0.871,1.321,1.496,1.808
          c0.623,0.484,1.338,0.844,2.145,1.078s1.65,0.352,2.535,0.352c0.919,0.017,1.785-0.135,2.6-0.455
          c0.815-0.321,1.529-0.776,2.145-1.365s1.105-1.287,1.47-2.094c0.364-0.805,0.546-1.676,0.546-2.612
          c0-0.849-0.126-1.651-0.377-2.405c-0.252-0.754-0.615-1.408-1.092-1.963s-1.062-0.997-1.756-1.326
          c-0.692-0.328-1.49-0.494-2.391-0.494c-0.729,0-1.379,0.109-1.951,0.326c-0.571,0.217-1.108,0.575-1.611,1.078l-0.053-0.052
          l0.729-4.134h7.514v-3.042H34.85l-1.793,10.062h3.327c0.364-0.503,0.755-0.871,1.171-1.105c0.416-0.233,0.952-0.35,1.611-0.35
          c0.503,0,0.945,0.086,1.326,0.26c0.381,0.172,0.711,0.416,0.988,0.728c0.276,0.312,0.484,0.676,0.623,1.092
          c0.14,0.416,0.209,0.858,0.209,1.326c0,0.451-0.074,0.89-0.222,1.313C41.943,45.114,41.734,45.486,41.467,45.807z"
          />
        </g>
      </g>
    </g>
  </svg>
)

export default Calendar



// WEBPACK FOOTER //
// ./src/components/Timesheet/Calendar.js